import post from '@app-src/data/api/post-to-api'
import { NativeLeadType } from './types'

/**
 * submitLead
 * @description posts the lead to the backend
 * takes an object with these members:
 * @param {Object} lead - the native lead object
 */
const submitLead = async ({
  lead,
  ...extraMiddleware
}: {
  lead: NativeLeadType
}): Promise<Response> =>
  post({
    fetchContext: 'Submit lead',
    ...extraMiddleware
  })('leads/api', 'v2/submit', lead)

export default submitLead
